import { notification } from 'antd';
import { track } from '../tracking';
import { DOCS_APP_BE_URL } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export const requestMedicalRecords = (
    docid: string,
    patientid: string,
    onSuccess?: () => void,
    onError?: () => void,
): void => {
    notification.info({
        message: 'Request Medical Records feature is coming soon!',
        duration: 2,
        placement: 'topRight',
    });

    // fetchWithRefresh(`${DOCS_APP_BE_URL}/service/sendmrlink?patientid=${patientid}&docid=${docid}`)
    //     .then((i) => i.json())
    //     .then((i) => {
    //         if (i.success) {
    //             onSuccess
    //                 ? onSuccess()
    //                 : notification.success({
    //                       message: `Medical Records Requested ✅. New records will appear upon refresh.`,
    //                       duration: 5,
    //                       placement: 'topRight',
    //                   });
    //         } else {
    //             onError
    //                 ? onError()
    //                 : notification.error({
    //                       message: i.error,
    //                       duration: 5,
    //                       placement: 'topRight',
    //                   });
    //             track('ERROR', { on: 'requestMedicalRecords', what: i.error });
    //         }
    //     })
    //     .catch((e) => {
    //         onError
    //             ? onError()
    //             : notification.error({
    //                   message: e.error,
    //                   duration: 5,
    //                   placement: 'topRight',
    //               });
    //         track('ERROR', { on: 'requestMedicalRecords', what: e.error });
    //     });
};
